WhatsRunningApp.Views.Reports = Backbone.View.extend({
    className: "col-lg-12",

    initialize: function() {
        var self = this;

        this.timer = function () {
            self.model.set({feeds : ['initial state']})
            self.model.fetch()
        }

        $('.reports').append(this.$el);

        $.ajax({
			url: '/assets/js/admin/whats-running/03_templates/reports.html',
			success: function(extTemplate) {
                self.template = _.template(extTemplate);
                self.render();
                self.model.fetch();
			},
			cache: false
        });

        setInterval(this.timer.bind(this), 15000);
        this.model.on('change', this.render, this);
    },

    render: function() {
        var model = this.model.toJSON();
        this.$el.html(this.template(model));

        if (model.reports.length != 1 || model.reports[0] != 'initial state') {
            $('.reports').toggleClass('sk-loading');
        }
    },

    close: function() {
        clearInterval(this.timer);
        this.remove();
        this.unbind();
    }
});